import { render, staticRenderFns } from "./ScriptTaskDetail.vue?vue&type=template&id=35380161&"
import script from "./ScriptTaskDetail.vue?vue&type=script&lang=js&"
export * from "./ScriptTaskDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35380161')) {
      api.createRecord('35380161', component.options)
    } else {
      api.reload('35380161', component.options)
    }
    module.hot.accept("./ScriptTaskDetail.vue?vue&type=template&id=35380161&", function () {
      api.rerender('35380161', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/gva-wfd/components/DetailPanel/ScriptTaskDetail.vue"
export default component.exports